export async function request<T>(url: string, options?: RequestInit): Promise<T> {
  const base = import.meta.env.VITE_API_BASE || '/api'
  const res = await fetch(`${base}${url}`, {
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
    ...options,
  })
  if (!res.ok) {
    throw new Error(`API Error: ${res.status} ${res.statusText}`)
  }
  return res.json() as Promise<T>
}
